import { Link } from 'react-router-dom';

const categories = [
  { key: 'movie', label: '电影', slug: 'dianying', icon: 'ri-movie-line', color: 'bg-primary-500' },
  { key: 'tv', label: '电视剧', slug: 'dianshiju', icon: 'ri-tv-line', color: 'bg-accent-500' },
  { key: 'variety', label: '综艺', slug: 'zongyi', icon: 'ri-live-line', color: 'bg-secondary-500' },
  { key: 'anime', label: '动漫', slug: 'dongman', icon: 'ri-rocket-line', color: 'bg-primary-600' },
  { key: 'documentary', label: '纪录片', slug: 'jilupian', icon: 'ri-earth-line', color: 'bg-accent-600' },
];

export default function CategoryTabs() {
  return (
    <section className="w-full px-4 md:px-6 -mt-8 relative z-20">
      <div className="max-w-[1400px] mx-auto">
        <div className="bg-background-50 rounded-xl p-4 md:p-5 shadow-sm">
          <div className="grid grid-cols-5 gap-2 md:gap-4">
            {categories.map((cat) => (
              <Link
                key={cat.key}
                to={`/category/${cat.slug}`}
                className="flex flex-col items-center gap-2 p-3 md:p-4 rounded-lg hover:bg-background-100 transition-all duration-300 group cursor-pointer"
              >
                <span className={`w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-xl ${cat.color} text-white transition-transform duration-300 group-hover:scale-110`}>
                  <i className={`${cat.icon} text-xl md:text-2xl`}></i>
                </span>
                <span className="text-xs md:text-sm font-medium text-foreground-700 group-hover:text-foreground-950 whitespace-nowrap">
                  {cat.label}
                </span>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}